import { environment } from '../../environment.ts'

/**
 * This will load the sidenav and wait for login to complete.
 * It expects the sidenav-app and script
 *
 * @returns after auth0 login completes
 */
export async function loadSidenavAndLogin() {
  loadSidenav()
  await waitForSidenavLogin()
}

/**
 * If the app already loads sidenav, this will simply wait for the login to complete
 *
 * @returns after auth0 login completes
 */
async function waitForSidenavLogin() {
  return new Promise<void>((resolve, reject) => {
    let sidenavInitCounter = 0
    //Because of potential race conditions, the boolean value should be checked
    //  before waiting for the event.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-member-access
    if ((window as any)?.sidenav?.isAuthenticationComplete) resolve()
    else {
      window.addEventListener('cwanAuthCompleted', () => {
        resolve()
      })

      const interval = setInterval(() => {
        if (sidenavInitCounter++ > 600) {
          clearInterval(interval)
          reject(new Error('Timed out waiting for sidenav init')) //if this happens, it could be that sidenav is not initializing FullStory in this environment (like stg)
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-member-access
        if ((window as any)?.sidenav?.isAuthenticationComplete) {
          clearInterval(interval)
          resolve()
        }
      }, 100) //check every 100ms
    }
  })
}

/**
 * Load the Clearwater Console sidenav, which handles navigation to other CW apps as well as logout.
 * This is not exactly a webcomponent, but behaves very similarly due to dynamically-loaded js
 * index.html has script tag placeholders, which we find by ID, and then set the source for the appropriate environment
 * When the script loads it finds sidenavApp div, gets its configuration, and draws itself there.
 */
function loadSidenav() {
  const now = Date.now()
  const baseUrl = environment.sidenavBaseUrl

  /**
   * Src app hook
   * Normally sidenav gets its config from the cwAuth0Config cookie set on the clearwater.com domain, after the user logs in via the single login page.
   *   but because CWAN GPT is not public yet, we can't get access to that cookie.
   * So for now, we'll *tell* sidenav, via these attributes, what the auth0 config is
   */
  let sidenavAppEl = document.getElementById('sidenavApp')
  let needsAppend = false
  if (!sidenavAppEl) {
    //uh-oh, you should really just put the sidenav in the body
    sidenavAppEl = document.createElement('div')
    sidenavAppEl.id = 'sidenavApp'
    needsAppend = true
  }

  //tell sidenav to handle the login, in addition to the auth token
  sidenavAppEl.setAttribute('isSideNavBasedLogin', 'true')

  if (needsAppend) document.body.appendChild(sidenavAppEl)

  /**
   * Sidenav Src script
   */
  const sidenavSrcEl = document.createElement('script')
  sidenavSrcEl?.setAttribute('src', `${baseUrl}/sidenavbar.js?v=${now}`)
  document.body.appendChild(sidenavSrcEl)
}
